import React, { useState, useRef, useEffect } from 'react'
import { Button } from 'primereact/button'
import { FileUpload } from 'primereact/fileupload'
import { Accordion, AccordionTab } from 'primereact/accordion'
import Fileimage from '../icon-file.svg'
import 'primeicons/primeicons.css'
import { InputText } from 'primereact/inputtext';
import { END_POINT } from '../config'

export default function Popup() {
  const [srsFileName, setSRSFileName] = useState('')
  const [requestName, setRequest] = useState('')
  const [btnMessage, setBtnMessage] = useState('Automate')
  const fileRef = useRef()

  const handlesubmit = async (event) => {
    setBtnMessage('Automating...')

    fileRef.current.clear()
    const response = await downloadfile(srsFileName)

    const blod = await response.blob()

    const url = window.URL.createObjectURL(new Blob([blod]))

    const link = document.createElement('a')

    link.href = url

    link.setAttribute('download', 'result.zip')

    document.body.appendChild(link)

    link.click()

    link.remove()

    setBtnMessage('Automate')
  }

  const downloadfile = async (srsFileName) => {
    try {
      const tokenString = localStorage.getItem('accounts')
      const userToken = JSON.parse(tokenString)

      //let url= "http://localhost:3001/runSRSAutomation?filename=" + "'" + srsFileName + "'&loginuser=" + "'" + userToken[0].name + "'&requestName=" + "'" + requestName + "'"

      const response = await fetch(
        `${END_POINT}runSRSAutomation/?filename=` +
          srsFileName +
          "&loginuser=" +
          userToken[0].name +
          "&requestName=" +
          requestName ,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          //body: JSON.stringify(newTodo)
        },
      )

      console.log(response)

      return response
    } catch (err) {
      throw new Error('Failed download file')
    }
  }

  const onSRSUpload = (e) => {
    console.log(e)
    if (e && e.files && e.files.length > 0) {
      let response = JSON.parse(e.xhr.responseText)
      setSRSFileName(response['filename'])
    }
  }

  return (
    <div className="width-100">
      <div className="text-right ml-3"></div>

      <div className="m-0">
        <div>
          <Accordion activeIndex={[0]} multiple>
            <AccordionTab header="Upload File">
              <div className="flex flex-row gap-6 padding-bottom-20 padding-top-10">
                <label htmlFor="requestName">Request Name</label>
                <InputText
                  id="requestName"
                  onChange={(e) => setRequest(e.target.value)}
                  required
                  autoFocus
                />
              </div>
              <div className="flex flex-row gap-5 padding-bottom-20">
                <label>Upload PDF:</label>
                <FileUpload
                  ref={fileRef}
                  name="srsPDF"
                  multiple
                  url={`${END_POINT}uploadfile`}
                  accept=".pdf"
                  chooseLabel="Upload"
                  onUpload={onSRSUpload}
                />
              </div>
            </AccordionTab>
          </Accordion>
          <div className="imageholder">
            <p className="placeholder-msg">
              Please Upload file and click on automate to automate files...
            </p>
            <Button label={btnMessage} onClick={handlesubmit}>
              
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
